// This registers a service worker that enables PWA features
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').then(registration => {
        console.log('✅ Service Worker registered: ', registration);
      }).catch(error => {
        console.error('❌ Service Worker registration failed:', error);
      });
    });
  }
}

// YEH NAYA FUNCTION ADD KIYA HAI PURANE CACHE KO HATANE KE LIYE
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister().then(() => {
          console.log('🛑 Service Worker unregistered successfully.');
        });
      })
      .catch((error) => {
        console.error('❌ Error during service worker unregistration:', error.message);
      });
  }
}